import { ControlIcons } from 'owa-control-icons';
import strings from 'owa-strings/owa-agenda-strings';

export function getProviderDetails(
    provider: string
): { icon: string | null; providerString: string } {
    switch (provider) {
        case 'SkypeForBusiness':
            return {
                icon: ControlIcons.SkypeForBusinessLogo16,
                providerString: strings.joinSkypeMeetingButton,
            };
        case 'SkypeForConsumer':
            return {
                icon: ControlIcons.SkypeLogo16,
                providerString: strings.joinSkypeMeetingButton,
            };
        case 'TeamsForBusiness':
            return { icon: ControlIcons.TeamsLogo, providerString: strings.joinTeamsMeetingButton };
        default:
            return { icon: null, providerString: strings.agendaJoinButtonText };
    }
}
